import { fetchData } from '../utils/netUtils';
import { resolveCurrentEnvironment } from '../utils/configUtils';

const unityUserService = {
  deleteUserDevice: async (tokenData, deviceID) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/devices/${deviceID}`;
    const options = {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserCurrentDevice: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/devices/current`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserDevices: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/devices`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserIdentity: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/identity`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserAccountInformation: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/accountinformation`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  },

  getUserUrns: async (tokenData) => {
    const currentENV = resolveCurrentEnvironment();
    let URL = `${currentENV.TBX_UNITY_API}/user/urns`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `${tokenData['auth_type']} ${tokenData['access_token']}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options);
  }
};

export default unityUserService;
